class SkipLink extends HTMLElement {
  connectedCallback() {
    // If the component doesn't wrap a focusable element (like an <a>), make the host itself focusable
    if (
      !this.querySelector('a') &&
      !this.querySelector('button') &&
      !this.hasAttribute('tabindex')
    ) {
      this.setAttribute('tabindex', '0')
      this.setAttribute('role', 'button')
    }
  }
}

if (!customElements.get('skip-link')) {
  customElements.define('skip-link', SkipLink)

  // Inject default visually-hidden-until-focused styles for skip links
  const style = document.createElement('style')
  style.textContent = `
    skip-link {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
      z-index: 9999;
    }
    skip-link:focus, skip-link:focus-within, skip-link:active {
      position: static;
      width: auto;
      height: auto;
      margin: 0;
      overflow: visible;
      clip: auto;
      white-space: normal;
      display: inline-block;
      /* Default visual styling when active */
      background-color: #ffffff;
      color: #000000;
      padding: 8px 16px;
      border: 2px solid #000000;
      text-decoration: underline;
    }
  `
  document.head.appendChild(style)
}

// Global delegated event listener for click on skip-links
document.addEventListener('click', (event) => {
  const skipLink = event.target.closest('skip-link')

  if (skipLink) {
    const targetSelector =
      skipLink.getAttribute('data-target') || skipLink.getAttribute('href')
    if (!targetSelector) return

    // Support both ID formats (data-target="my-id" or data-target="#my-id")
    const formattedSelector = targetSelector.startsWith('#')
      ? targetSelector
      : `#${targetSelector}`
    const targetEl = document.querySelector(formattedSelector)

    if (targetEl) {
      event.preventDefault()

      // Ensure target can receive programmatic focus
      if (!targetEl.hasAttribute('tabindex')) {
        targetEl.setAttribute('tabindex', '-1')
      }

      targetEl.focus()
    }
  }
})

document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    const skipLink = event.target.closest('skip-link')
    if (
      skipLink &&
      document.activeElement === skipLink &&
      !skipLink.querySelector('a')
    ) {
      event.preventDefault()
      skipLink.click()
    }
  }
})
